"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Wallet", {
  enumerable: true,
  get: function get() {
    return _wallet.Wallet;
  }
});

var _wallet = require("./wallet");